/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Soilingpercentage1Inputs */



/**
* | output |
* | --- |
* | "Soiling percentage" |
*
* @param {Ahu_History_Key_Soilingpercentage1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_soilingpercentage1 = /** @type {((inputs?: Ahu_History_Key_Soilingpercentage1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Soilingpercentage1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Soiling percentage")
	return /** @type {LocalizedString} */ ("Pourcentage d'encrassement")
});
export { ahu_history_key_soilingpercentage1 as "ahu_history_key_soilingPercentage" }